export default {
  title: {
    en: 'Fragrance Collections',
  },
  text: {
    en: `
      <span aria-hidden="true">
        We've created capsule collections around our most popular perfume and cologne categories to make it
        easier for you to discover all new scents in no time.
      </span>
    `,
  },
}
